import { SelectMultiOptionWrapper } from "./SelectMultiOptionWrapper.js";
import "react";
import { ColorSquare } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Select/SelectGroupValueMulti.tsx
var SelectGroupValueMulti = ({ color, label, onRemove }) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "px-xs flex max-w-full items-center",
		children: [!!color && /* @__PURE__ */ jsx(ColorSquare, {
			color,
			marginRight: true
		}), /* @__PURE__ */ jsx("div", {
			className: "truncate text-sm",
			children: label
		})]
	})
});
//#endregion
export { SelectGroupValueMulti };

//# sourceMappingURL=SelectGroupValueMulti.js.map